export default "__VITE_ASSET__oU8qQ_Se__"